// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"542":"f5ded97e","787":"e644c21f","955":"746fadfc"}[chunkId] + ".chunk.js";
};